import React, { useCallback, useState } from 'react'
import { useAuthFlow } from '../../Context/AuthFlowContext';
import { useUser } from '../../Context/UserContext';
import { useNav } from '../../Context/NavContext';
import { useNavigate } from 'react-router-dom';
import GoogleAuthButton from './GoogleAuthButton';

function Login() {
  const { toggleAuthFlow } = useAuthFlow();
  const { login, loginWithGoogle } = useUser();
  const { setActiveItem } = useNav();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user types
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.email || !formData.password) {
      setError('Please fill in all fields');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);

      if (result.success) {
        // Clear form
        setFormData({
          email: '',
          password: ''
        });

        // Check if user is admin
        if (result.user.role === 'admin') {
          navigate('/admin');
        } else {
          // Set active item to COLLECTION to show the collection page
          setActiveItem('COLLECTION');
        }
        
        // Close the login form
        toggleAuthFlow();
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = useCallback(async (credential) => {
    if (loading) {
      return;
    }

    setError('');
    setLoading(true);

    try {
      const result = await loginWithGoogle(credential);

      if (result.success) {
        if (result.user.role === 'admin') {
          navigate('/admin');
        } else {
          setActiveItem('COLLECTION');
        }

        toggleAuthFlow();
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      console.error('Google login error:', err);
    } finally {
      setLoading(false);
    }
  }, [loading, loginWithGoogle, navigate, setActiveItem, toggleAuthFlow]);

  return (
    <div className='login_container'>
      <form onSubmit={handleSubmit}>
        <div className="log_title">
          <h2>Login</h2>
        </div>
        {error && (
          <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
            {error}
          </div>
        )}
        <input 
          type="email" 
          name="email"
          placeholder='Email'
          value={formData.email}
          onChange={handleChange}
          disabled={loading}
          required
        />
        <input 
          type="password" 
          name="password"
          placeholder='Password'
          value={formData.password}
          onChange={handleChange}
          disabled={loading}
          required
        />
        <div className="forget">
          <a href="#" onClick={(e) => e.preventDefault()}>forget your password?</a>
          <a href="#" onClick={(e) => {e.preventDefault(); toggleAuthFlow();}}>
            create a account
          </a>
        </div>
        <div className="log_btn">
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </div>
        <GoogleAuthButton onCredential={handleGoogleLogin} disabled={loading} text="signin_with" />
      </form>
    </div>
  )
}

export default Login
